import(/* webpackMode: "eager", webpackExports: ["ShoppingCartPageContainer"] */ "/vercel/path0/apps/portals/src/app/[portalSlug]/(main)/shopping-cart/container.tsx");
